const STRIKE_COUNT_RESULTS = new Set([
  "swinging_strike",
  "called_strike",
  "foul",
  "in_play",
  "ball_in_play",
]);

const BALL_RESULTS = new Set(["ball"]);
const IN_PLAY_RESULTS = new Set(["in_play", "ball_in_play"]);
const STRIKEOUT_RESULTS = new Set(["strikeout_swinging", "strikeout_looking"]);
const WALK_RESULTS = new Set(["walk"]);
const HIT_BY_PITCH_RESULTS = new Set(["hit_by_pitch", "hbp"]);
const TERMINAL_RESULTS = new Set([
  ...STRIKEOUT_RESULTS,
  ...WALK_RESULTS,
  ...HIT_BY_PITCH_RESULTS,
  ...IN_PLAY_RESULTS,
]);

const SWING_RESULTS = new Set([
  "swinging_strike",
  "foul",
  ...IN_PLAY_RESULTS,
  "strikeout_swinging",
]);

export const normalizePitchResult = (result) =>
  typeof result === "string" ? result.toLowerCase() : "";

export const isFoulResult = (result) =>
  normalizePitchResult(result) === "foul";

export const isBallResult = (result) =>
  BALL_RESULTS.has(normalizePitchResult(result));

export const isInPlayResult = (result) =>
  IN_PLAY_RESULTS.has(normalizePitchResult(result));

export const isStrikeoutResult = (result) =>
  STRIKEOUT_RESULTS.has(normalizePitchResult(result));

export const isWalkResult = (result) =>
  WALK_RESULTS.has(normalizePitchResult(result));

export const isHitByPitchResult = (result) =>
  HIT_BY_PITCH_RESULTS.has(normalizePitchResult(result));

export const isSwingResult = (result) =>
  SWING_RESULTS.has(normalizePitchResult(result));

export const isWhiffResult = (result) => {
  const normalized = normalizePitchResult(result);
  return normalized === "swinging_strike" || normalized === "strikeout_swinging";
};

export const isTerminalPitchResult = (result) =>
  TERMINAL_RESULTS.has(normalizePitchResult(result));

export const doesPitchIncrementStrikeCount = (result, currentStrikes = 0) => {
  const normalized = normalizePitchResult(result);
  if (!STRIKE_COUNT_RESULTS.has(normalized)) return false;
  if (normalized === "foul" && currentStrikes >= 2) return false;
  return true;
};

export const isStrikeForPercentage = (result) => {
  const normalized = normalizePitchResult(result);
  return (
    normalized.includes("strike") ||
    normalized === "foul" ||
    IN_PLAY_RESULTS.has(normalized)
  );
};

export const countStrikesFromResultMap = (results = {}) =>
  Object.entries(results).reduce((total, [result, count]) => {
    if (!Number.isFinite(count)) return total;
    return isStrikeForPercentage(result) ? total + count : total;
  }, 0);
